import { toNumber } from 'lodash-es';
import {
  _handleFavorite,
  _handleHaXiFavorite,
  getGameInfo,
  goBlockGame,
  goBYThirdPlatform,
  goDZThirdPlatform,
  goQPThirdPlatform,
  goThirdLotteryGame,
  goThirdPlatform,
  goTianChengPlatform,
  goTYThirdPlatform,
  goZRThirdPlatform,
  handleServerGameImg,
  testCanPlay,
} from '@/plugins/game';
import { ref } from 'vue';
import { mb_err, mb_t } from '@/plugins/global';
import { G_goLogin, transferThirdGameUrl } from '@/plugins/public_utils';
import { closeDialog, showConfirmDialog, showDialog } from 'vant';
import { emitter, EventEnum } from '@star/utils';
import { storeToRefs, useGameStore, useHaxiStore, useModalStore, useSportsStore, useUserStore } from '@star/stores';
import { GameMainKeysEnum, GameMainTypesEnum, gameMainTypesMap, ModalTypeEnum } from '@star/constants';
import { ConfigUtils } from '@star/config';
import { getChanCon } from '@/hooks/message';
import { router } from '@/routers';

const modalStore = useModalStore();
export const getHotGameImgSrc = (
  pathName: GameMainKeysEnum,
  item: any,
  imgType: 'dark' | 'light' | 'color' = 'dark'
) => {
  return handleServerGameImg(item.logo3_img_url) || `/images/game/${pathName}/${imgType}_${item.upper_play_id}.png`;
};

export const openGame = (item: any) => {
  const { activeHomeMainMenuTab, gamesTryPlayIds } = storeToRefs(useGameStore());
  const { isLogin, isFreeUser, userInfo } = storeToRefs(useUserStore());
  const type = item.mainType ?? toNumber(activeHomeMainMenuTab.value);
  console.log(type, item, 'openGame');
  console.log(location, 'location.pathname');
  if (item.state === 2 || item.play_state === 2) return;
  if (!isLogin.value && type !== GameMainTypesEnum.TRIAL && gamesTryPlayIds.value.includes(item.play_id)) {
    showConfirmDialog({
      title: '温馨提示',
      message: '试玩额度不能用于提款哦',
      // theme: 'round-button',
      closeOnClickOverlay: true,
      className: 'tryGameComfirm',
      showCancelButton: true,
      confirmButtonText: '登录',
      cancelButtonText: '立即试玩',
    })
      .then(() => {
        modalStore.showModal(ModalTypeEnum.LOGIN_REGISTER_MODAL);
        removeCloseBtn();
      })
      .catch(() => {
        goThirdPlatform(item, GameMainKeysEnum.CHESS, true);
        removeCloseBtn();
      });

    const closeBtn = document.createElement('div');
    closeBtn.className = 'custom-close-btn';
    closeBtn.innerHTML = '×';

    const closeDialogHandle = () => {
      closeDialog();
      removeCloseBtn();
    };

    const removeCloseBtn = () => {
      // @ts-ignore
      document.querySelector('.tryGameComfirm .van-dialog__header').removeChild(closeBtn);
      closeBtn.removeEventListener('click', closeDialogHandle);
    };

    // 动态插入关闭按钮
    setTimeout(() => {
      // @ts-ignore
      document.querySelector('.tryGameComfirm .van-dialog__header').appendChild(closeBtn);

      // 监听关闭按钮点击
      closeBtn.addEventListener('click', closeDialogHandle);
    }, 0);

    return false;
  }
  switch (type) {
    case GameMainTypesEnum.HOT_GAME:
      goThirdPlatform(item, GameMainKeysEnum.CHESS);
      break;
    case GameMainTypesEnum.TRIAL:
      goThirdPlatform(item, GameMainKeysEnum.CHESS, true);
      break;
    case GameMainTypesEnum.COLLECT:
      handleEnterCollectGame1(item);
      break;
    case GameMainTypesEnum.RECENT:
      handleEnterRecentGame(item);
      break;
    case GameMainTypesEnum.LOTTERY:
      console.log('=====game', item, userInfo);
      goThirdLotteryGame(item);
      // if (isThirdPlatformLottery(item.type)) {
      //   goThirdLotteryGame(item)
      // } else {
      //   goMNLotteryGame(item)
      // }
      break;
    case GameMainTypesEnum.BLOCK:
      break;
    default:
      goThirdPlatform(item, gameMainTypesMap[type]);
  }
};

// 收藏
const gameType = ref();
const gamesTabs = ref();
// 收藏
const originalGames = ['crash', 'mine', 'dabble', 'dice'];
const haxi = ['HASH_ZHUANGXIAN', 'HASH_LUCKNUMBER', 'HASH_LUCKY', 'HASH_NIUNIU5', 'HASH_NORMALNIUNIU', 'HASH_PK10'];
const handleEnterCollectGame1 = item => {
  let { _type, type } = item;
  _type = _type || type;
  if (haxi.includes(item.play_name) || originalGames.includes(item.play_name)) {
    _type = 0;
  }
  let bigType = item.play_big_type;

  if (bigType === 'dianzi') {
    router.push('/game?key=electronic' + '&upper_play_id=' + item.play_id);
    return;
  } else if (bigType === 'qipai') {
    router.push('/game?key=chess' + '&upper_play_id=' + item.play_id);
    return;
  }
  const play = ConfigUtils.getPlayInfo(item.play_id);
  switch (_type) {
    case 11:
      goZRThirdPlatform(item);
      break;
    case 12:
      goDZThirdPlatform(item);
      break;
    case 13:
      goBYThirdPlatform(item);
      break;
    case 14: // 红包
      mb_err('功能待开发', 2);
      break;
    case 15:
      goTYThirdPlatform(item);
      break;
    case 16:
      item._isTiancheng === '1' ? goTianChengPlatform(item) : testCanPlay(play);
      break;
    case 17:
      goQPThirdPlatform(item);
      break;
    case 37:
      goThirdLotteryGame(item);
      break;
    case 0:
      goBlockGame(item);
  }
};

const handleFavoriteHaxi = async (item, isHot = false) => {
  const gameStore = useGameStore();
  const haxiStore = useHaxiStore();
  if (item.isOriginal) {
    // 原创游戏
    item.play_name = item.name;
    item.play_cname = item.showName;
  } else {
    item.play_name = item.play?.name;
    item.play_cname = item.play?.showname;
  }
  item.status = item.is_collect === 2 ? 2 : 1;
  item.play_collection = item.is_collect === 2 ? 2 : 1;
  const data = {
    ...item,
  };
  await _handleHaXiFavorite(data);
  if (isHot) {
    await gameStore.getTotalGamesPlatform({ chan_con: getChanCon() });
  } else {
    if (item.isOriginal) {
      await gameStore.reqOriginalGames();
    } else {
      await haxiStore.getGameList();
    }
  }
};

// 收藏
export const handleFavorite = async (item: any) => {
  const { activeHomeMainMenuTab, activeHomeSubMenuTab } = storeToRefs(useGameStore());
  const mainType = toNumber(activeHomeMainMenuTab.value);
  // const subType = toNumber(activeHomeSubMenuTab.value);
  let data = {
    ...item,
    play_id: item.play_id || item.playId,
    status: item.status || item.gameState,
    play_collection: item.play_collection ?? item.status,
  };
  let type = 0;
  if (mainType == GameMainTypesEnum.CHESS) type = 17;
  if (mainType == GameMainTypesEnum.ELECTRONIC) type = 12;
  if (item.isLotteryTicket) {
    data._type = 16;
    type = item.type || 16;
  }
  const { gameType }: any = getGameInfo(item);
  const cb = async () => {
    const gameStore = useGameStore();
    await gameStore.getTotalGamesPlatform({ chan_con: getChanCon() });
    emitter.emit(EventEnum.REFRESH_HOME_GAMES, { mainType: gameType, reset: false });
  };
  const result = await _handleFavorite(data, '', type);
  if (result) {
    item.play_collection = (item.play_collection ?? item.status) === 1 ? 2 : 1;
    await cb();
  }
};

export const handleFavorite1 = async (item: any) => {
  if (item.type === 'hash') {
    await handleFavoriteHaxi(item);
  } else {
    const { activeHomeMainMenuTab } = storeToRefs(useGameStore());
    let data = {
      ...item,
      play_id: item.play_id || item.playId,
      status: item.status || item.gameState,
      play_collection: item.play_collection || item.status,
    };
    const gameInfo: any = getGameInfo(item);
    let type = item.type || item._type || gameInfo.fav_type || 0;
    const cb = async () => {
      const gameStore = useGameStore();
      await gameStore.getTotalGamesPlatform({ chan_con: getChanCon(), collection: true });
      emitter.emit(EventEnum.REFRESH_HOME_GAMES, { mainType: gameInfo.gameType, reset: false });
    };
    const result = await _handleFavorite(data, '', type);
    if (result) {
      item.play_collection = (item.play_collection ?? item.status) === 1 ? 2 : 1;
      await cb();
    }
  }
};

// 最近玩过
const handleEnterRecentGame = item => {
  const play = ConfigUtils.getPlayInfo(item.play_id);
  const gameType = item.gameType;
  switch (gameType) {
    case 'ZR':
      goZRThirdPlatform(item);
      break;
    case 'DZ':
    case 'QKL':
      goDZThirdPlatform(item);
      break;
    case 'BY':
      goBYThirdPlatform(item);
      break;
    case 'TY':
      goTYThirdPlatform(item);
      break;
    case 16:
      item._isTiancheng === '1' ? goTianChengPlatform(item) : testCanPlay(play);
      break;
    case 'QP':
      goQPThirdPlatform(item);
      break;
    case 0:
      goBlockGame(item);
  }
};

// 棋牌
const enterQPGame = value => {
  const gameStore = useGameStore();
  const sportsStore = useSportsStore();
  const { isLogin, isFreeUser, userInfo } = storeToRefs(useUserStore());

  const close3Game = async thirdGameId => {
    await sportsStore.reqTransitionAllYe({
      play_id: thirdGameId,
      type: 3,
    });
    setTimeout(() => {
      sportsStore.reqBlanceCollect();
    }, 1000);
  };
  const goLinkGame = info => {
    if (info.target === '_self') {
      // router.push('/iframe');
      router.push({ path: '/game/iframe', query: { from: location.pathname } });
    } else {
      window.open(info.url);
    }
  };
  const jump3Game = info => {
    let data = {} as any;
    if (info.playId === 504) {
      data.isMobileOpen = 1;
      data.type = info.play_name;
    }
    if ((info.playId || info.play_id) === 1326) {
      data.type = 1;
    } else {
      data.type = info.code || info.play_name;
    }
    info.gameId = info.upperId;
    const payload = {
      data: data,
      play_id: info.upperId || info.play_id,
    };
    if (payload.play_id === 1313) {
      // PRETTY真人
      payload.data.type = '1';
    }
    gameStore.get3GameUrl(payload).then((res: any) => {
      if (res && res.url) {
        const _urlInfo = transferThirdGameUrl(res.url, payload, info);
        goLinkGame(_urlInfo);
        info._params = { data, play_id: info.upperId };
      }
    });
  };
  const goTianCheng = info => {
    if (!isLogin.value) {
      G_goLogin();
      return;
    }
    if (isFreeUser.value) {
      showDialog({
        title: mb_t('提示'),
        message: mb_t('试玩账号不能进入该游戏、请注册正式会员'),
        confirmButtonText: mb_t('去注册'),
        cancelButtonText: mb_t('下次吧'),
      })
        .then(() => {
          router.replace('/');
        })
        .catch(() => {
          router.back();
        });
      return;
    }
    gameStore
      .checking3Game({
        play_id: info.playId || info.play_id,
      })
      .then((res: any) => {
        if (res.response_code && res.response_code === '9999') {
          jump3Game(info);
        }
      })
      .catch(err => {
        if (err.exMessage) {
          mb_err(err.exMessage.toString());
        } else if (err.info) {
          mb_err(err.info.toString());
        }
      });
  };
  const playChatGame = (playid, url) => {
    let play = ConfigUtils.getPlayInfo(playid);
    gameStore
      .reqChatByNames({
        play_names: play.play_name,
      })
      .then(res => {
        if (res) {
          let roomType: any;
          for (let key in res) {
            let itemType = res[key];
            if (!roomType) {
              roomType = itemType;
            }
            if (Number(itemType.room_type_id) === Number(gameStore.roomTypeId)) {
              roomType = itemType;
              break;
            }
          }
          // 设置房间类型
          if (roomType) {
            if (roomType.playRooms) {
              let room = null;
              for (let i = 0; i < roomType.playRooms.length; i++) {
                let roomItem = roomType.playRooms[i];
                if (!room) {
                  room = roomItem;
                }
                if (Number(roomItem.play_room_id) === Number(gameStore.roomId)) {
                  room = roomItem;
                  break;
                }
              }
              if (room) {
                gameStore.setCurRoomType(roomType);
                gameStore.setCurRoom(room);
                router.push(url);
              }
            }
          }
        }
      })
      .catch(err => {
        mb_err(err.info);
      });
  };
  const goToElotGame = value => {
    if (!isLogin.value) {
      G_goLogin();
      mb_err('亲，请先登录哦', 2);
      return;
    }
    if (userInfo.value.fict_flag) {
      if (value.type === 3 || value.type === 4 || value.type === 5 || value.type === 8) {
        const url = '/pk10?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.type === 6) {
        let url;
        if (value.play_id === 33) {
          url = '/hklottery?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
          router.push(url);
        } else if (value.play_id === 42) {
          url = '/cqlhc?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
          router.push(url);
        }
      } else if (value.type === 7) {
        const url = '/game/k3?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.type === 2) {
        const url = '/roomchat?playid=' + value.play_id;
        playChatGame(value.play_id, url);
      } else if (value.type === 0) {
        router.push('/ydc?playid=' + value.play_id);
      } else if (value.type === 19) {
        const url = '/fc3d?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.type === 20) {
        router.push('/xnb?playid=' + value.play_id);
      } else if (value.type === 21) {
        router.push('/qkl?playid=' + value.play_id);
      }
    } else {
      if (value.type === 3 || value.type === 4 || value.type === 5 || value.type === 8) {
        const url = '/pk10?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.type === 6) {
        let url;
        if (value.play_id !== 42) {
          url = '/hklottery?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
          router.push(url);
        } else if (value.play_id === 42) {
          url = '/cqlhc?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
          router.push(url);
        }
      } else if (value.type === 7) {
        if (value.play_cat === 4) {
          const url = '/pk10?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
          router.push(url);
        } else {
          // const url = '/game/k3?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
          // console.log(router, '444444444444444444444');
          // router.push(url);
          router.push({
            path: '/game/k3',
            query: { playid: value.play_id, subplayid: value.sub_play_id },
          });
        }
      } else if (value.type === 2) {
        const url = '/roomchat?playid=' + value.play_id;
        playChatGame(value.play_id, url);
      } else if (value.type === 0) {
        router.push('/ydc?playid=' + value.play_id);
      } else if (value.type === 19) {
        const url = '/fc3d?playid=' + value.play_id + '&goback=0&subplayid=' + value.sub_play_id;
        router.push(url);
      } else if (value.type === 20) {
        router.push('/xnb?playid=' + value.play_id);
      } else if (value.type === 21) {
        router.push('/qkl?playid=' + value.play_id);
      }
    }
  };

  if (value.isOtherCP || value.play_id === 1326 || value.play_id === 1385) {
    goTianCheng(value);
    return;
  }

  if (isLogin.value) {
    gameStore
      .checking3Game({
        play_id: value.play_id,
      })
      .then((res: any) => {
        if (res?.response_code === '9999') {
          goToElotGame(value);
        }
      })
      .catch(err => {
        console.log(err, '999999900000');
        let rToaastTxt = '';
        const repTxt = '已停盘，开盘时间为';
        if (err.toString().indexOf('正处于内测中') !== -1) {
          if (userInfo.value.fict_flag) {
            goToElotGame(value);
            return;
          }
          rToaastTxt = mb_t(err.toString());
        } else if (err.info?.toString()?.indexOf(repTxt) !== -1) {
          rToaastTxt = `${mb_t(err.info?.toString()?.split(':')[0])}${err.info?.toString()?.split(':')[1]}`;
        } else {
          rToaastTxt = mb_t(err.info?.toString());
        }
        mb_err(rToaastTxt);
      });
  } else {
    G_goLogin();
  }
};
